<template>
  <div class="landing-page-bg" aria-hidden="true">
    <div class="landing-page-bg__gradient" />
    <svg class="landing-page-bg__neural" viewBox="0 0 1440 900" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="neural-line-a" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stop-color="#0071e3" stop-opacity="0.35" />
          <stop offset="100%" stop-color="#6366f1" stop-opacity="0.2" />
        </linearGradient>
      </defs>
      <g class="landing-page-bg__edges" fill="none" stroke="url(#neural-line-a)" stroke-width="1">
        <path d="M120 180 Q 320 120 480 220 T 720 160 T 980 240 T 1320 140" opacity="0.5" />
        <path d="M80 420 Q 280 360 440 480 T 760 400 T 1100 520 T 1360 380" opacity="0.45" />
        <path d="M200 680 Q 400 620 560 720 T 880 660 T 1180 760 T 1340 600" opacity="0.4" />
        <path d="M360 120 L 520 280 L 680 200 L 840 340 L 1000 260" opacity="0.35" stroke-width="0.75" />
        <path d="M240 520 L 400 400 L 620 540 L 800 460 L 1020 580" opacity="0.35" stroke-width="0.75" />
        <path d="M500 640 L 720 560 L 920 700 L 1120 620" opacity="0.3" stroke-width="0.75" />
        <line x1="480" y1="220" x2="680" y2="200" opacity="0.4" />
        <line x1="680" y1="200" x2="840" y2="340" opacity="0.35" />
        <line x1="440" y1="480" x2="620" y2="540" opacity="0.35" />
        <line x1="620" y1="540" x2="800" y2="460" opacity="0.3" />
        <line x1="720" y1="160" x2="980" y2="240" opacity="0.35" />
        <line x1="560" y1="720" x2="920" y2="700" opacity="0.3" />
      </g>
      <g class="landing-page-bg__nodes" fill="#0071e3">
        <circle class="landing-page-bg__node landing-page-bg__node--pulse" cx="120" cy="180" r="5" opacity="0.22" />
        <circle cx="480" cy="220" r="4" opacity="0.18" />
        <circle cx="720" cy="160" r="5" opacity="0.2" />
        <circle cx="980" cy="240" r="4" opacity="0.16" />
        <circle cx="1320" cy="140" r="4" opacity="0.14" />
        <circle cx="440" cy="480" r="5" opacity="0.2" />
        <circle cx="800" cy="460" r="4" opacity="0.17" />
        <circle class="landing-page-bg__node landing-page-bg__node--pulse landing-page-bg__node--delay" cx="1100" cy="520" r="5" opacity="0.2" />
        <circle cx="360" cy="120" r="3" opacity="0.14" />
        <circle cx="840" cy="340" r="4" opacity="0.16" />
        <circle cx="560" cy="720" r="5" opacity="0.18" />
        <circle cx="1120" cy="620" r="4" opacity="0.15" />
        <circle cx="200" cy="680" r="3" opacity="0.12" />
      </g>
    </svg>
    <div class="landing-page-bg__vignette" />
  </div>
</template>

<style scoped>
.landing-page-bg {
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  overflow: hidden;
}

.landing-page-bg__gradient {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(ellipse 70% 55% at 15% 8%, rgba(41, 151, 255, 0.14), transparent 55%),
    radial-gradient(ellipse 55% 45% at 88% 12%, rgba(99, 102, 241, 0.12), transparent 50%),
    radial-gradient(ellipse 60% 40% at 50% 100%, rgba(41, 151, 255, 0.08), transparent 55%),
    linear-gradient(165deg, #f8fafc 0%, #eef4ff 42%, #f5f3ff 78%, #f0f4fa 100%);
}

.landing-page-bg__neural {
  position: absolute;
  inset: -5%;
  width: 110%;
  height: 110%;
  opacity: 0.55;
}

.landing-page-bg__vignette {
  position: absolute;
  inset: 0;
  background: radial-gradient(ellipse 85% 75% at 50% 45%, transparent 40%, rgba(248, 250, 252, 0.65) 100%);
}

.landing-page-bg__node--pulse {
  animation: neural-pulse 4s ease-in-out infinite;
}

.landing-page-bg__node--delay {
  animation-delay: 2s;
}

@keyframes neural-pulse {
  0%,
  100% {
    opacity: 0.14;
    r: 4;
  }
  50% {
    opacity: 0.28;
    r: 6;
  }
}

@media (prefers-reduced-motion: reduce) {
  .landing-page-bg__node--pulse {
    animation: none;
  }
}
</style>
